import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { switchMap } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { StaffAuthService } from '../staff/auth';

@Injectable({
  providedIn: 'root',
})
export class IssueTrackerService {
  constructor(
    private http: HttpClient,
    private auth: StaffAuthService,
  ) {}

  getToken() {
    const url = `${environment.restApiV5Host}/issue-tracker/token`;
    return this.auth.getAccessToken().pipe(
      switchMap((access_token) => {
        return this.http.get(url, {
          headers: { Authorization: 'Bearer ' + access_token },
          responseType: 'text',
        });
      }),
    );
  }
}
